import { ShowIconLink } from '@/components/common/ShowIconLink';
import { orDash } from '@/components/common/show/shared';
import { ACTIVITY_SUBJECT_RESOURCE } from '@/pages/system/activities/constants';

interface ActivitySubjectProps {
  type: string | null;
  id: number | null;
}

/**
 * An audit row's subject or target: `Type #id`, linked when that model has a
 * show route. The two fields carry the same shape, so both the list columns
 * and the show header render through this.
 */
export const ActivitySubject = ({ type, id }: ActivitySubjectProps) => {
  if (!type) return <>{orDash(null)}</>;
  const label = id != null ? `${type} #${id}` : type;
  const resource = ACTIVITY_SUBJECT_RESOURCE[type];
  if (!resource || id == null) return <>{label}</>;
  return (
    <ShowIconLink resource={resource} id={id}>
      {label}
    </ShowIconLink>
  );
};
